import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="spinner"></div>
        <h1>Software Under Maintenance</h1>
        <p>We are performing updates. Please check back soon.</p>
      </header>
    </div>
  );
}

export default App;
